import { createContext, ReactNode, useContext } from 'react';
import {
    MemberGenderLabel,
    MissionStatusLabel,
    MemberStatusLabel,
    MemberTypeLabel,
    MissionVisibilityLabel,
    AntennaTypeLabel,
    VolunteerMissionAffinityLabel,
    ResourceTypeLabel,
    TaskTypeLabel,
} from '@domain/labels';

// Define types for the context value
export interface ConfigurationContextValue {
    antennaTypes: AntennaTypeLabel[];
    missionPipelineStatuses: string[];
    missionStatusLabels: MissionStatusLabel[];
    memberStatusLabels: MemberStatusLabel[];
    memberGenderLabels: MemberGenderLabel[];
    memberTypeLabels: MemberTypeLabel[];
    missionVisibilityLabels: MissionVisibilityLabel[];
    resourceTypeLabels: ResourceTypeLabel[];
    volunteerMissionAffinityLabels: VolunteerMissionAffinityLabel[];
    taskTypeLabels: TaskTypeLabel[];
    title: string;
    logo: string;
    country: string;
    language: string;
}

export interface ConfigurationProviderProps extends ConfigurationContextValue {
    children: ReactNode;
}

// Create context with default value
export const ConfigurationContext = createContext<ConfigurationContextValue>({
    country: 'fr',
    language: 'en',
    antennaTypes: [],
    missionPipelineStatuses: [],
    missionStatusLabels: [],
    memberStatusLabels: [],
    logo: '',
    taskTypeLabels: [],
    title: '',
    memberGenderLabels: [],
    memberTypeLabels: [],
    missionVisibilityLabels: [],
    resourceTypeLabels: [],
    volunteerMissionAffinityLabels: [],
});

export const ConfigurationProvider = ({
    country,
    language,
    children,
    antennaTypes,
    missionPipelineStatuses,
    missionStatusLabels,
    logo,
    memberStatusLabels,
    taskTypeLabels,
    title,
    memberGenderLabels,
    memberTypeLabels,
    missionVisibilityLabels,
    resourceTypeLabels,
    volunteerMissionAffinityLabels,
}: ConfigurationProviderProps) => (
    <ConfigurationContext.Provider
        value={{
            antennaTypes,
            missionPipelineStatuses,
            missionStatusLabels,
            logo,
            memberStatusLabels,
            title,
            taskTypeLabels,
            memberGenderLabels,
            memberTypeLabels,
            missionVisibilityLabels,
            resourceTypeLabels,
            volunteerMissionAffinityLabels,
            country,
            language,
        }}
    >
        {children}
    </ConfigurationContext.Provider>
);

export const useConfigurationContext = () => useContext(ConfigurationContext);
